import { assetsCollectionElement } from '../types'

// Where the starred asset sits in the collection, or the first slot when nothing is starred.
// Located, never computed: the collection's own order is the only thing that knows the layout.
export const defaultAssetIndex = (assetsCollection: assetsCollectionElement[]): number => {
  const index = assetsCollection.findIndex(asset =>
    'product' in asset ? asset.product?.default : 'default' in asset && asset.default
  )
  return -1 === index ? 0 : index
}
